import { NgModule } from '@angular/core';
import { SignalRModule } from '@epicuro-next/data/signalr';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { ConnectTokenStateModule } from '@epicuro-next/state/connect-token-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SignalrEffects } from './state/signalr.effects';
import { reducer, signalrFeatureKey } from './state/signalr.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(signalrFeatureKey, reducer),
    EffectsModule.forFeature([SignalrEffects]),
    SignalRModule,
    AccountsStateModule,
    ConnectTokenStateModule,
  ],
})
export class SignalrStateModule {}
